import { _, isWidgetEventKey, tpl } from '@zto/zpage'
import type { PageContext } from '@zto/zpage'

import type { AppBoardItemConfig } from './types'

/**
 * 获取board payload
 * @param payload
 * @param context
 * @returns
 */
export async function getPayloadData(payload: any, context: any) {
  if (_.isFunction(payload)) {
    return await payload(context)
  } else if (Array.isArray(payload)) {
    const result = payload.reduce((acc: any, key: string) => {
      if (key) acc[key] = _.get(context, key)
      return acc
    }, {})
    return result
  } else {
    return payload
  }
}

/** 计算表单项属性 */
export function normalizeBoardItemConfig(config: AppBoardItemConfig | Function, context: PageContext) {
  const app = context.app

  let boardItem: AppBoardItemConfig = config as AppBoardItemConfig

  // @ts-ignore
  if (_.isFunction(config)) boardItem = config(context)

  if (boardItem.dynamicAttrs) {
    const dynamicAttrs = calcDynamicAttrs(boardItem.dynamicAttrs, context)

    boardItem = _.omit(boardItem, ['dynamicAttrs'])
    boardItem = _.deepMerge(boardItem, dynamicAttrs)
  }

  normalizeBoardItemType(boardItem)

  const realSpan = boardItem.span || 0

  const it: any = {}

  // 移除微件事件Key，防止重复计算事件
  Object.keys(boardItem).forEach(key => {
    // @ts-ignore
    if (!isWidgetEventKey(key)) it[key] = boardItem[key]
  })

  const componentType = boardItem.componentType ? app.resolveComponent(boardItem.componentType) : null
  const componentAttrs = _.omit(it, ['type', 'componentType', 'span'])

  return { ...it, componentAttrs, realSpan, componentType }
}

/**
 * 整理boardItem属性
 * 内置组件 已注册过组件 传string类型即可
 * 支持扩展Component itemType传Component对象 - example -  foo: { label:"自定义组件", itemType : ElInput}
 * @param itemType
 */
export function normalizeBoardItemType(boardItem: any) {
  if (!boardItem) return boardItem
  if (boardItem.componentType) return boardItem

  let type = boardItem.type || 'html'

  if (typeof type === 'string') {
    boardItem.componentType = `c-board-item-${type}`
  } else {
    boardItem.componentType = type
  }

  return boardItem
}

/** 计算动态属性 */
export function calcDynamicAttrs(dynamicAttrs: any, context: any) {
  let _attrs: any = {}

  if (_.isFunction(dynamicAttrs)) {
    _attrs = dynamicAttrs(context)
  } else if (typeof dynamicAttrs === 'object') {
    _attrs = tpl.deepFilter(dynamicAttrs, context)
  } else if (typeof dynamicAttrs === 'string') {
    _attrs = tpl.evalJS(dynamicAttrs, context)
  }

  return _attrs
}
